import { call, put, takeLatest, getContext } from "redux-saga/effects";

// alerts
function* openAlertSaga({ payload }) {}

function* modalRootSaga() {
  yield takeLatest("ui/openAlert", openAlertSaga);
}

export default modalRootSaga;
